import React, { useMemo } from 'react';
import OrganizationAnalyticsBarChart from './OrganizationAnalyticsBarChart';
import { mapIdsToLabels } from './chartUtils';

const OrganizationChatterOffersByChatterChart = ({ data, chatterLabelMap, pending }) => {
  const { categories, series } = useMemo(
    () => ({
      categories: mapIdsToLabels(data?.chatterIds, chatterLabelMap),
      series: [{ name: 'Offers', data: data?.offerCount || [] }],
    }),
    [data, chatterLabelMap],
  );

  return (
    <OrganizationAnalyticsBarChart
      title="Offers By Chatter"
      subtitle="Offer volume for the selected chatters."
      categories={categories}
      series={series}
      pending={pending}
      emptyText="Select creators and chatters to load offer totals."
      valueType="number"
    />
  );
};

export default OrganizationChatterOffersByChatterChart;
